import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'echexpayment-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css'],
  providers: [Modal]
})
export class StatusComponent implements OnInit {
	busy: Subscription;
	public token: string;
	public status = <any>{};
	public data;
	public filterQuery = "";
	public rowsOnPage = 10;
	public sortBy = "Id";
	public sortOrder = "asc";

	private color: string = "#127bdc";
	private dataNotFound: string;

	constructor(private router: Router, vcRef: ViewContainerRef, public modal: Modal, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 

	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;


	}

	ngOnInit() {
		this.getAllStatus();
	}
	// Get all status
	getAllStatus() {
		var data = {
			token :this.token
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getAllStatusData(data).subscribe(
			response => {
				responseData = response;
				this.data = responseData.data;
				if(this.data.length == 0){
					 this.dataNotFound =  responseData.message
				}
			},
			error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			}
		);
	}

	// Delete status
	deleteStatus(event,s_id){
		event.stopPropagation();
		this.modal.confirm()
		.size('sm')
		.title('CasherPay')
		.body(`Are you sure to delete this status. ` )
		.okBtn('Okay')
		.cancelBtn('Cancel')
		.okBtnClass('btn btn-success')
		.cancelBtnClass('btn btn-warning')
		.open()
		.then( (resultPromise) => {
		  resultPromise.result.then( (result) => {
			var data = {
			  token:s_id,
			  user_token:this.token,
			  id:s_id
			}
		  let responseData = <any>{};	
		  this.busy = this.echexpaymentService.deleteStatus(data).subscribe(
			   response => {
				responseData = response;
				this.toastr.success(responseData.message, 'Success!');
				this.getAllStatus();
			   },
			   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			   }
		  );
		}, 
		() => {
		 console.log('Cancel');
		} );
		});
	}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/status/status.component.ts